<template>
  <v-app-bar app color="primary" dark clipped-left>
    <v-app-bar-nav-icon @click="drawer = !drawer" />
    <v-toolbar-title>{{ toolbar.title }}</v-toolbar-title>
    <v-spacer />
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon class="mdi mdi-account-circle" />
        </v-btn>
      </template>
      <v-card width="450">
        <v-list>
          <v-list-item two-line v-if="usuarioAtivo">
            <v-list-item-content>
              <v-list-item-title>{{usuarioAtivo.nome}}</v-list-item-title>
              <v-list-item-subtitle>{{usuarioAtivo.login}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="empresaAtiva"
            @click="$store.commit('usuarios/trocarEmpresaDialog', true)"
          >
            <v-list-item-action>
              <v-icon class="mdi mdi-domain" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>{{empresaAtiva.cnpj}}</v-list-item-subtitle>
              <v-list-item-title>{{empresaAtiva.razao_social}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="$store.commit('usuarios/toggleChangePasswordDialog', true)">
            <v-list-item-action>
              <v-icon class="mdi mdi-lock-reset" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Alterar senha</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item @click="logout()">
            <v-list-item-action>
              <v-icon class="mdi mdi-logout" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      toolbar: state => state.ui.toolbar,
      usuarioAtivo: state => state.usuarios.usuarioAtivo,
      empresaAtiva: state => state.usuarios.empresaAtiva
    }),
    drawer: {
      get() {
        return this.$store.state.ui.drawer.open;
      },
      set(value) {
        this.$store.commit("ui/toggleDrawer", value);
      }
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("usuarios/logout");
      this.$router.replace({ name: "auth-login" });
    }
  }
};
</script>
